import { app } from '../../../../app';
import { roleTypes } from '../../../../components/sp-role-type/sp-role-type.exports';
import { lazyLoad } from '../../../../lib/lazy-load';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-administrator-audit', {
        url: '/reports/administrator-audit',
        component: 'companyReportsAdministratorAudit',
        resolve: {logs$},
    })
}

/** @ngInject */
function logs$(companyId, StatisticsResource) {
    return roleTypes.reduce((byType, t) => ({
        ...byType,
        [t]: lazyLoad(() => StatisticsResource.getCompanyAdminAudits(companyId, t))
    }), {});
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/administrator-audit/administrator-audit.state.js